import { confirmAsync } from '../../utils/confirm';
import { DeleteButton } from '../../components/ActionButtons';
import DataTable, { Rozet } from '../../components/DataTable';
import { useState, useEffect } from 'react';
import { apiRequest } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import { useKasa } from '../../context/KasaContext';
import UsageInfo from '../../components/UsageInfo';

const inputClass = 'w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300';
const labelClass = 'block text-xs font-semibold text-gray-500 mb-1';

export default function WalkInAdisyon() {
  const { personel } = useAuth();
  const { odemeTipleri, bankalar, dovizKurlari, paraBirimleri } = useKasa();

  const [stoklar, setStoklar] = useState([]);
  const [adisyonlar, setAdisyonlar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(false);

  // Adisyon formu
  const [form, setForm] = useState({
    misafirAdi: '',
    stokId: null, stokAdi: '', _aramaModu: true, _dropdown: false,
    miktar: 1, birimFiyat: 0, iskonto: 0, not: '', satisNoktasi: 'Restoran',
  });
  const [stokArama, setStokArama] = useState('');
  const [kaydediliyor, setKaydediliyor] = useState(false);

  // Ödeme formu
  const [odeModal, setOdeModal] = useState(null); // { adisyonId, stokAdi, toplamTutar, odenenTutar }
  const [odeForm, setOdeForm] = useState({ odemeTipi: '', paraBirimi: 'TL', bankaAdi: '', tutar: '' });
  const [odeYukleniyor, setOdeYukleniyor] = useState(false);

  // Filtre
  const [filtreMisafir, setFiltreMisafir] = useState('');
  const [filtreOdendi, setFiltreOdendi] = useState('hepsi');

  useEffect(() => {
    apiRequest('stok').then(d => setStoklar(d || [])).catch(() => {});
    yukle();
  }, []);

  useEffect(() => {
    if (odemeTipleri.length > 0 && !odeForm.odemeTipi) {
      const nakit = odemeTipleri.find(o => o.ad?.toLowerCase().includes('nakit'));
      setOdeForm(p => ({ ...p, odemeTipi: (nakit || odemeTipleri[0]).ad }));
    }
  }, [odemeTipleri]);

  async function yukle() {
    setYukleniyor(true);
    try {
      const data = await apiRequest('adisyonlar/walk-in');
      setAdisyonlar(data || []);
    } catch { /* sessiz */ }
    setYukleniyor(false);
  }

  async function handleEkle() {
    if (!form.stokAdi.trim()) { alert('Ürün adı zorunludur.'); return; }
    if (parseFloat(form.birimFiyat) <= 0) { alert('Birim fiyat giriniz.'); return; }
    const toplamOnce = (parseFloat(form.miktar) || 1) * (parseFloat(form.birimFiyat) || 0) - (parseFloat(form.iskonto) || 0);
    if (toplamOnce < 0) { alert('İskonto tutarı toplam tutardan büyük olamaz.'); return; }
    setKaydediliyor(true);
    try {
      await apiRequest('adisyonlar', 'POST', {
        misafirAdi: form.misafirAdi.trim() || null,
        stokId: form.stokId || null,
        stokAdi: form.stokAdi,
        miktar: parseFloat(form.miktar) || 1,
        birimFiyat: parseFloat(form.birimFiyat) || 0,
        iskonto: parseFloat(form.iskonto) || 0,
        not: form.not,
        satisNoktasi: form.satisNoktasi || null,
        rezervasyonId: null,
        personelId: personel?.personelId || 1,
      });
      setForm(p => ({ misafirAdi: '', stokId: null, stokAdi: '', _aramaModu: true, _dropdown: false, miktar: 1, birimFiyat: 0, iskonto: 0, not: '', satisNoktasi: p.satisNoktasi }));
      setStokArama('');
      await yukle();
    } catch (e) { alert(e.message || 'Kayıt başarısız.'); }
    setKaydediliyor(false);
  }

  async function handleSil(id) {
    if (!(await confirmAsync())) return;
    try {
      await apiRequest(`adisyonlar/${id}`, 'DELETE');
      await yukle();
    } catch (e) { alert(e?.message || 'Silinemedi.'); }
  }

  async function handleOde() {
    if (!odeForm.odemeTipi) { alert('Ödeme tipi seçiniz.'); return; }
    const tutar = parseFloat(odeForm.tutar);
    if (!tutar || tutar <= 0) { alert('Geçerli bir tutar giriniz.'); return; }
    setOdeYukleniyor(true);
    try {
      const kur = dovizKurlari[odeForm.paraBirimi] || 1;
      const bankaGerekli = odeForm.odemeTipi && !odeForm.odemeTipi.toLowerCase().includes('nakit') && bankalar.length > 0;
      await apiRequest(`adisyonlar/${odeModal.adisyonId}/ode`, 'POST', {
        odemeTipi: odeForm.odemeTipi,
        paraBirimi: odeForm.paraBirimi,
        kurDegeri: kur,
        bankaAdi: bankaGerekli ? odeForm.bankaAdi : '',
        tutar,
        personelId: personel?.personelId || 1,
      });
      setOdeModal(null);
      await yukle();
    } catch (e) { alert(e.message || 'Ödeme başarısız.'); }
    setOdeYukleniyor(false);
  }

  const filtrelenmis = adisyonlar
    .filter(a => !filtreMisafir || (a.misafirAdi || '').toLocaleLowerCase('tr-TR').includes(filtreMisafir.toLocaleLowerCase('tr-TR')) || a.stokAdi.toLocaleLowerCase('tr-TR').includes(filtreMisafir.toLocaleLowerCase('tr-TR')))
    .filter(a => filtreOdendi === 'hepsi' ? true : filtreOdendi === 'odendi' ? a.odemeyapildiMi : !a.odemeyapildiMi);

  const bekleyen = adisyonlar.filter(a => !a.odemeyapildiMi).reduce((s, a) => s + a.toplamTutar, 0);

  return (
    <div className="min-h-screen bg-[#f8fafc] pb-20">
      {/* ── Header ── */}
      <div className="bg-[#0f172a] pt-12 pb-24 px-8 relative overflow-hidden shadow-[0_20px_50px_rgba(15,23,42,0.3)]">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-indigo-500/10 rounded-full -translate-y-1/2 translate-x-1/3 blur-[100px] pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-blue-500/10 rounded-full translate-y-1/2 -translate-x-1/2 blur-[80px] pointer-events-none" />

        <div className="max-w-[1600px] mx-auto flex flex-col md:flex-row md:items-center justify-between gap-8 relative z-10">
          <div>
            <div className="flex items-center gap-3 mb-4 opacity-50">
              <span className="text-white text-[10px] font-black tracking-[0.3em] uppercase">Mali İşlemler</span>
              <span className="text-white/20">/</span>
              <span className="text-white text-[10px] font-black tracking-[0.3em] uppercase">Hızlı Satış</span>
            </div>
            <div className="flex items-center gap-6">
              <div className="w-20 h-20 bg-white/5 backdrop-blur-2xl rounded-[2.5rem] border border-white/10 flex items-center justify-center text-4xl shadow-2xl relative group overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <span className="relative z-10">🛒</span>
              </div>
              <div>
                <h1 className="text-5xl font-black text-white tracking-tighter leading-tight drop-shadow-2xl">Walk-in Adisyon</h1>
                <p className="text-indigo-400 text-[10px] font-black uppercase tracking-widest mt-3 leading-none flex items-center gap-2">
                  <span className="w-2 h-2 bg-indigo-400 rounded-full animate-pulse blur-[1px]" />
                  Rezervasyonsuz Hızlı Ekstra ve Hizmet Satışı
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex gap-4">
            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-4 min-w-[180px]">
              <p className="text-white/50 text-[10px] font-black uppercase tracking-widest mb-1">Toplam Tahsilat</p>
              <p className="text-2xl font-black text-white">{filtrelenmis.filter(a => a.odemeyapildiMi).reduce((s, a) => s + (a.toplamTutar || 0), 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</p>
            </div>
            {bekleyen > 0 && (
              <div className="bg-rose-500/10 backdrop-blur-md border border-rose-500/20 rounded-2xl p-4 min-w-[180px] relative overflow-hidden group">
                <div className="absolute top-0 right-0 p-4 text-rose-500/20 group-hover:scale-125 transition-transform">⚠️</div>
                <p className="text-rose-400 text-[10px] font-black uppercase tracking-widest mb-1 flex items-center gap-1.5">
                   <span className="w-1.5 h-1.5 bg-rose-500 rounded-full animate-pulse" />
                   Bekleyen Tutar
                </p>
                <p className="text-2xl font-black text-rose-300">{bekleyen.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="max-w-[1600px] mx-auto px-8 -mt-10 relative z-20">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          
          {/* ── SOL: YENİ KALEM EKLE ── */}
          <div className="bg-white rounded-[2rem] border border-gray-100 shadow-xl p-8 space-y-6 relative overflow-hidden h-fit animate-slideInLeft">
            <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-50 rounded-bl-full flex items-center justify-center -z-0">
               <span className="text-4xl opacity-20 -mt-8 -mr-8">🧾</span>
            </div>
            <div className="relative z-10 space-y-6">
              <h3 className="font-black text-lg text-gray-800 flex items-center gap-3 tracking-tight border-b border-gray-100 pb-4">
                <span className="w-10 h-10 bg-indigo-50 text-indigo-500 rounded-xl flex items-center justify-center text-lg shadow-sm border border-indigo-100">+</span>
                Yeni Kalem Satışı
              </h3>

              <div>
                <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Misafir Adı (Opsiyonel)</label>
                <input className={`${inputClass} !rounded-xl !py-4 focus:ring-indigo-100`}
                  placeholder="Ahmet Yılmaz veya boş bırak..."
                  value={form.misafirAdi} onChange={e => setForm(p => ({ ...p, misafirAdi: e.target.value }))} />
              </div>

              <div>
                <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Ürün / Hizmet Kalemi *</label>
                <div className="relative">
                  {form.stokAdi && !form._aramaModu ? (
                    <div className="flex items-center gap-3 bg-indigo-50/50 border border-indigo-100 rounded-xl p-2 pr-4 shadow-sm">
                      <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-sm text-indigo-400 text-lg">🏷️</div>
                      <span className="flex-1 text-sm font-bold text-indigo-900 truncate">{form.stokAdi}</span>
                      <button type="button" onClick={() => { setForm(p => ({ ...p, stokAdi: '', stokId: null, _aramaModu: true })); setStokArama(''); }}
                        className="w-8 h-8 flex items-center justify-center bg-white text-rose-400 hover:text-white hover:bg-rose-500 rounded-lg transition-colors font-bold shadow-sm">✕</button>
                    </div>
                  ) : (
                    <input className={`${inputClass} !rounded-xl !py-4 focus:ring-indigo-100`}
                      placeholder="Ürün seç veya ismini yaz..."
                      autoFocus={form._aramaModu} value={stokArama}
                      onChange={e => { setStokArama(e.target.value); setForm(p => ({ ...p, _dropdown: true })); }}
                      onFocus={() => setForm(p => ({ ...p, _dropdown: true }))}
                      onBlur={() => setTimeout(() => setForm(p => ({ ...p, _dropdown: false })), 200)} />
                  )}

                  {/* Dropdown Menu */}
                  {form._dropdown && (
                    <div className="absolute top-full left-0 right-0 mt-2 bg-white/90 backdrop-blur-xl border border-gray-100 rounded-2xl shadow-2xl z-50 max-h-56 overflow-y-auto custom-scrollbar p-2 animate-scaleIn origin-top">
                      {stoklar
                        .filter(s => !stokArama || s.ad?.toLocaleLowerCase('tr-TR').includes(stokArama.toLocaleLowerCase('tr-TR')))
                        .map(s => (
                          <button key={s.stokId} type="button"
                            onMouseDown={() => {
                              setForm(p => ({ ...p, stokAdi: s.ad, stokId: s.stokId, birimFiyat: s.satisFiyat || 0, _dropdown: false, _aramaModu: false }));
                              setStokArama('');
                            }}
                            className="w-full text-left px-4 py-3 text-sm hover:bg-gray-50 flex items-center justify-between rounded-xl group transition-colors">
                            <span className="font-semibold text-gray-700 group-hover:text-indigo-600 transition-colors">{s.ad}</span>
                            <span className="text-xs font-black text-gray-400 bg-white px-2 py-1 rounded shadow-sm group-hover:text-indigo-500 transition-colors">{s.satisFiyat?.toLocaleString('tr-TR')} ₺</span>
                          </button>
                        ))}
                      {stokArama && !stoklar.find(s => s.ad?.toLowerCase() === stokArama.toLowerCase()) && (
                        <button type="button" onMouseDown={() => {
                          setForm(p => ({ ...p, stokAdi: stokArama, stokId: null, _dropdown: false, _aramaModu: false }));
                        }} className="w-full text-left px-4 py-3 text-sm text-indigo-600 bg-indigo-50 hover:bg-indigo-100 rounded-xl font-bold transition-colors mt-1">
                          + &quot;{stokArama}&quot; isminde serbest satış ekle
                        </button>
                      )}
                      {stoklar.filter(s => !stokArama || s.ad?.toLowerCase().includes(stokArama.toLowerCase())).length === 0 && !stokArama && (
                        <div className="px-4 py-6 text-center text-xs font-bold text-gray-400 uppercase tracking-widest">Kayıtlı Varyasyon Bulunamadı</div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Miktar</label>
                  <input type="number" min="0.5" step="0.5" className={`${inputClass} !rounded-xl !py-4 focus:ring-indigo-100`}
                    value={form.miktar} onChange={e => setForm(p => ({ ...p, miktar: e.target.value }))} />
                </div>
                <div>
                  <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Birim Fiyat (₺)</label>
                  <input type="number" min="0" className={`${inputClass} !rounded-xl !py-4 focus:ring-indigo-100`}
                    value={form.birimFiyat} onChange={e => setForm(p => ({ ...p, birimFiyat: e.target.value }))} />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">İskonto (₺)</label>
                  <input type="number" min="0" className={`${inputClass} !rounded-xl !py-4 focus:ring-indigo-100 text-rose-500`}
                    value={form.iskonto} onChange={e => setForm(p => ({ ...p, iskonto: e.target.value }))} />
                </div>
                <div>
                  <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Not</label>
                  <input className={`${inputClass} !rounded-xl !py-4 focus:ring-indigo-100`} placeholder="Açıklama..."
                    value={form.not} onChange={e => setForm(p => ({ ...p, not: e.target.value }))} />
                </div>
              </div>

              {/* Satış noktası — ciro dökümü bu alana göre alınır */}
              <div>
                <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Satış Noktası</label>
                <select className={`${inputClass} !rounded-xl !py-4 focus:ring-indigo-100`}
                  value={form.satisNoktasi} onChange={e => setForm(p => ({ ...p, satisNoktasi: e.target.value }))}>
                  {['Restoran', 'Kafe', 'Vitamin Bar', 'Havuz Bar', 'Oda Servisi', 'Resepsiyon', 'Diğer']
                    .map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>

              <div className="bg-gradient-to-r from-gray-50 to-indigo-50 border border-indigo-100/50 rounded-2xl px-6 py-5 flex items-center justify-between shadow-inner">
                <span className="text-[10px] font-black text-indigo-500 uppercase tracking-widest">TOPLAM TUTAR</span>
                <span className="text-2xl font-black text-indigo-700 tracking-tight">
                  {((parseFloat(form.miktar) || 1) * (parseFloat(form.birimFiyat) || 0) - (parseFloat(form.iskonto) || 0)).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                </span>
              </div>

              <button onClick={handleEkle} disabled={kaydediliyor}
                className="w-full bg-gradient-to-r from-indigo-500 to-blue-600 hover:opacity-90 text-white rounded-2xl py-5 text-[11px] font-black uppercase tracking-[0.2em] shadow-[0_10px_20px_-10px_rgba(99,102,241,0.5)] transition-all hover:-translate-y-1 disabled:opacity-50 !mt-8">
                {kaydediliyor ? 'İŞLENİYOR...' : '🛒 LİSTEYE EKLE'}
              </button>
            </div>
          </div>

          {/* ── SAĞ: DATA LİSTESİ ── */}
          <div className="lg:col-span-2 bg-white rounded-[2rem] border border-gray-100 shadow-xl overflow-hidden animate-slideInRight flex flex-col min-h-[400px]">
            {/* Filtre Bar */}
            <div className="p-6 border-b border-gray-100 flex flex-wrap items-center gap-4 bg-gray-50/50 backdrop-blur-md relative z-10">
              <input className={`${inputClass} !w-64 !rounded-xl border-gray-200`}
                placeholder="Misafir adı veya satılan ürünü ara..."
                value={filtreMisafir} onChange={e => setFiltreMisafir(e.target.value)} />
              <select className={`${inputClass} !w-auto !rounded-xl border-gray-200 px-4`}
                value={filtreOdendi} onChange={e => setFiltreOdendi(e.target.value)}>
                <option value="hepsi">Adisyon Durumu: Tümü</option>
                <option value="bekliyor">Henüz Tahsil Edilmeyenler</option>
                <option value="odendi">Ödemesi Alınanlar</option>
              </select>
              {(filtreMisafir || filtreOdendi !== 'hepsi') && (
                <button onClick={() => { setFiltreMisafir(''); setFiltreOdendi('hepsi'); }}
                  className="text-[10px] font-black text-rose-500 hover:text-white hover:bg-rose-500 transition-all uppercase tracking-widest px-4 py-3 rounded-xl border border-rose-100 hover:border-rose-500 ml-auto hidden sm:flex items-center gap-2">
                  ✕ Temizle
                </button>
              )}
              <div className="hidden lg:flex flex-col items-end ml-auto">
                 <span className="text-[9px] font-black text-gray-400 uppercase tracking-[0.2em]">Sonuç</span>
                 <span className="text-lg font-black text-gray-800 leading-none">{filtrelenmis.length}</span>
              </div>
            </div>

            {yukleniyor ? (
              <div className="flex-1 flex items-center justify-center p-20">
                 <div className="w-12 h-12 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin shadow-lg"/>
              </div>
            ) : filtrelenmis.length === 0 ? (
              <div className="flex-1 flex flex-col items-center justify-center p-20">
                <div className="w-32 h-32 bg-gray-50 rounded-full flex items-center justify-center text-6xl shadow-inner mb-6 opacity-50 relative">
                   <span className="relative z-10">📋</span>
                   <div className="absolute inset-0 border-4 border-dashed border-gray-200 rounded-full animate-spin-slow"/>
                </div>
                <h3 className="text-xl font-black text-gray-800 tracking-tight">Kayıt Bulunamadı</h3>
                <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest mt-2 text-center max-w-xs leading-relaxed">
                  Belirlediğiniz kriterlere uygun sonuç yok veya liste tamamen boş.
                </p>
              </div>
            ) : (
              <div className="overflow-x-auto flex-1 custom-scrollbar">
                {/* Mobil Liste */}
                <div className="sm:hidden flex flex-col divide-y divide-gray-50">
                  {filtrelenmis.map(a => (
                    <div key={a.adisyonId} className="p-5 flex flex-col gap-3">
                      <div className="flex justify-between items-start">
                        <div>
                           <p className="font-bold text-gray-800 text-sm">{a.stokAdi}</p>
                           <p className="text-xs font-semibold text-gray-400 mt-0.5">{a.misafirAdi || <span className="opacity-50">SADE SATIŞ</span>}</p>
                        </div>
                        {a.odemeyapildiMi ? (
                           <span className="bg-emerald-50 text-emerald-600 border border-emerald-100 text-[9px] font-black px-2 py-1 uppercase rounded-md shadow-sm">Ödendi</span>
                         ) : (
                           <span className="bg-rose-50 text-rose-600 border border-rose-100 text-[9px] font-black px-2 py-1 uppercase rounded-md shadow-sm">Bekliyor</span>
                         )}
                      </div>
                      <div className="flex justify-between items-center text-xs mt-2 bg-gray-50 p-3 rounded-xl border border-gray-100/50">
                         <span className="font-medium text-gray-500">{a.miktar} × {a.birimFiyat?.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                         <span className="font-black text-lg text-gray-800 tracking-tight">{a.toplamTutar?.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                      </div>
                      <div className="flex items-center justify-end gap-2 mt-2">
                        {!a.odemeyapildiMi && (
                          <button onClick={() => { setOdeModal({ adisyonId: a.adisyonId, stokAdi: a.stokAdi, toplamTutar: a.toplamTutar, odenenTutar: a.odenenTutar || 0 }); setOdeForm(p => ({ ...p, tutar: (a.toplamTutar - (a.odenenTutar || 0)).toFixed(2) })); }}
                            className="bg-emerald-100 active:bg-emerald-200 text-emerald-700 px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest shadow-sm">Öde</button>
                        )}
                        <button onClick={() => handleSil(a.adisyonId)} className="text-rose-500 bg-rose-50 border border-rose-100 text-[10px] font-black uppercase tracking-widest px-4 py-2 rounded-xl">Sil</button>
                      </div>
                    </div>
                  ))}
                </div>
                
                {/* Desktop Tablo */}
                <div className="hidden sm:block">
                <DataTable
                  anahtarAlan="adisyonId"
                  satirlar={filtrelenmis}
                  bosIkon="🧾"
                  bosMetin="Adisyon kaydı bulunamadı"
                  kolonlar={[
                    {
                      anahtar: 'olusturmaTarihi', baslik: 'Tarih', siralanir: true,
                      ciz: a => (
                        <span className="whitespace-nowrap font-semibold text-gray-500 text-xs bg-gray-50 px-2 py-1 rounded-md border border-gray-100">
                          {new Date(a.olusturmaTarihi).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
                          <span className="text-[10px] ml-1 opacity-60">
                            | {new Date(a.olusturmaTarihi).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit' })}
                          </span>
                        </span>
                      ),
                    },
                    {
                      anahtar: 'stokAdi', baslik: 'Kalem Bilgisi', siralanir: true, filtrelenir: true,
                      ciz: a => (
                        <div>
                          <div className="font-bold text-gray-800 text-sm">{a.stokAdi}</div>
                          <div className="text-[10px] font-black text-gray-400 uppercase tracking-widest mt-1 opacity-70">
                            {a.misafirAdi ? <span>👤 {a.misafirAdi}</span> : <span className="opacity-50">Sade satış</span>}
                          </div>
                          {a.not && <p className="text-[9px] font-bold text-gray-300 uppercase mt-1">Not: {a.not}</p>}
                        </div>
                      ),
                    },
                    {
                      anahtar: 'miktar', baslik: 'Miktar', hizala: 'orta', siralanir: true,
                      ciz: a => (
                        <span className="bg-white border border-gray-100 text-xs font-black text-gray-600 px-3 py-1 rounded-lg inline-block">
                          {a.miktar}
                        </span>
                      ),
                    },
                    {
                      anahtar: 'toplamTutar', baslik: 'Birim / Toplam', hizala: 'sag', siralanir: true,
                      ciz: a => (
                        <div className="flex flex-col items-end">
                          <span className="font-black text-lg text-gray-800 tracking-tighter leading-none">
                            {a.toplamTutar?.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                          </span>
                          <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest mt-1">
                            Birim: {a.birimFiyat?.toLocaleString('tr-TR')} ₺
                          </span>
                        </div>
                      ),
                    },
                    {
                      anahtar: 'odemeyapildiMi', baslik: 'Durum', hizala: 'orta', siralanir: true,
                      ciz: a => (
                        <Rozet renk={a.odemeyapildiMi ? 'emerald' : 'rose'}>
                          {a.odemeyapildiMi ? 'Ödendi' : 'Bekliyor'}
                        </Rozet>
                      ),
                    },
                    {
                      anahtar: 'islem', baslik: 'İşlem', hizala: 'sag',
                      ciz: a => (
                        <div className="flex items-center gap-2 justify-end">
                          {!a.odemeyapildiMi && (
                            <button onClick={() => {
                                setOdeModal({ adisyonId: a.adisyonId, stokAdi: a.stokAdi, toplamTutar: a.toplamTutar, odenenTutar: a.odenenTutar || 0 });
                                setOdeForm(p => ({ ...p, tutar: (a.toplamTutar - (a.odenenTutar || 0)).toFixed(2) }));
                              }}
                              className="flex items-center gap-2 text-[10px] bg-emerald-50 hover:bg-emerald-600 hover:text-white text-emerald-600 border border-emerald-100 px-3 py-2 rounded-xl font-black uppercase tracking-widest transition-all">
                              💰 Ödeme al
                            </button>
                          )}
                          <DeleteButton onClick={() => handleSil(a.adisyonId)} />
                        </div>
                      ),
                    },
                  ]}
                />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ── ÖDEME MODALI ── */}
      {odeModal && (
        <div className="fixed inset-0 bg-gray-900/40 backdrop-blur-sm z-[200] flex items-end sm:items-center justify-center sm:p-4 animate-fadeIn" onClick={() => setOdeModal(null)}>
          <div className="bg-white rounded-t-[2.5rem] sm:rounded-[2.5rem] p-8 w-full sm:max-w-md shadow-2xl relative overflow-hidden animate-scaleIn origin-bottom sm:origin-center" onClick={e => e.stopPropagation()}>
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-emerald-400 to-teal-500" />
            
            {/* Mobil Sürükleme Çubuğu */}
            <div className="flex justify-center -mt-4 mb-6 sm:hidden">
              <div className="w-12 h-1.5 bg-gray-200 rounded-full"/>
            </div>

            <div className="flex items-center justify-between mb-8">
              <h3 className="font-black text-2xl text-gray-800 flex items-center gap-3 tracking-tight">
                <span className="w-12 h-12 bg-emerald-50 text-emerald-500 rounded-2xl flex items-center justify-center shadow-inner border border-emerald-100 text-xl">
                  💰
                </span>
                Tahsilat Al
              </h3>
              <button onClick={() => setOdeModal(null)} className="text-gray-400 hover:text-gray-600 bg-gray-50 hover:bg-gray-100 w-10 h-10 rounded-full flex items-center justify-center transition-colors font-black">✕</button>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-5 mb-8 border border-emerald-100/50 shadow-inner">
              <div className="flex items-center justify-between mb-3 pb-3 border-b border-emerald-100/50">
                <div className="flex flex-col">
                  <span className="text-[10px] font-black text-emerald-600/70 uppercase tracking-widest">KALEM BİLGİSİ</span>
                  <span className="font-bold text-emerald-900 line-clamp-1">{odeModal.stokAdi}</span>
                </div>
                <div className="flex flex-col items-end">
                  <span className="text-[10px] font-black text-emerald-600/70 uppercase tracking-widest">TOPLAM</span>
                  <span className="font-bold text-emerald-900">{odeModal.toplamTutar?.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <div className="flex flex-col">
                  {odeModal.odenenTutar > 0 ? (
                    <>
                      <span className="text-[10px] font-black text-emerald-600/70 uppercase tracking-widest">ÖDENEN</span>
                      <span className="font-bold text-emerald-600">{odeModal.odenenTutar?.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                    </>
                  ) : <div/>}
                </div>
                <div className="flex flex-col items-end">
                  <span className="text-[10px] font-black text-rose-500 uppercase tracking-widest">KALAN BAKİYE</span>
                  <span className="font-black text-xl text-rose-600">{(odeModal.toplamTutar - odeModal.odenenTutar).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                </div>
              </div>
            </div>

            <div className="space-y-5">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Ödeme Tipi *</label>
                  <select className={`${inputClass} !rounded-xl !py-4 border-gray-200 focus:ring-emerald-100`} value={odeForm.odemeTipi} onChange={e => setOdeForm(p => ({ ...p, odemeTipi: e.target.value }))}>
                    {odemeTipleri.map(o => <option key={o.ad} value={o.ad}>{o.ad}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Para Birimi</label>
                  <select className={`${inputClass} !rounded-xl !py-4 border-gray-200 focus:ring-emerald-100`} value={odeForm.paraBirimi} onChange={e => setOdeForm(p => ({ ...p, paraBirimi: e.target.value }))}>
                    <option value="TL">TL</option>
                    {(paraBirimleri || []).filter(p => p.tcmbKod !== 'TL' && p.tcmbKod !== 'TRY').map(p => (
                      <option key={p.tcmbKod} value={p.tcmbKod}>{p.tcmbKod}</option>
                    ))}
                  </select>
                </div>
              </div>

              {odeForm.odemeTipi && !odeForm.odemeTipi.toLowerCase().includes('nakit') && bankalar.length > 0 && (
                <div className="animate-scaleIn origin-top">
                  <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Banka Hesabı</label>
                  <select className={`${inputClass} !rounded-xl !py-4 border-gray-200 focus:ring-emerald-100`} value={odeForm.bankaAdi} onChange={e => setOdeForm(p => ({ ...p, bankaAdi: e.target.value }))}>
                    <option value="">Seçiniz</option>
                    {bankalar.map(b => <option key={b.ad} value={b.ad}>{b.ad}</option>)}
                  </select>
                </div>
              )}

              <div>
                <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Tahsil Edilecek Tutar ({odeForm.paraBirimi})</label>
                <div className="relative">
                  <input type="number" min="0" step="0.01" className={`${inputClass} text-lg py-4 border-emerald-100 focus:border-emerald-500 focus:ring-emerald-50 rounded-xl`}
                    value={odeForm.tutar}
                    onChange={e => setOdeForm(p => ({ ...p, tutar: e.target.value }))} />
                  <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[10px] font-black text-gray-400">{odeForm.paraBirimi}</span>
                </div>
                {odeForm.paraBirimi !== 'TL' && odeForm.paraBirimi !== 'TRY' && dovizKurlari[odeForm.paraBirimi] > 0 && parseFloat(odeForm.tutar) > 0 && (
                  <p className="text-[10px] font-black text-emerald-600 bg-emerald-50 px-3 py-2 rounded-xl mt-2 inline-flex items-center gap-1.5 uppercase tracking-widest animate-fadeIn">
                     KARŞILIĞI: {(parseFloat(odeForm.tutar) * dovizKurlari[odeForm.paraBirimi]).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                  </p>
                )}
              </div>

              <div className="flex gap-4 pt-4">
                <button onClick={() => setOdeModal(null)} className="flex-1 border-2 border-gray-100 rounded-2xl py-4 text-[11px] font-black text-gray-500 hover:bg-gray-50 transition uppercase tracking-widest">İptal</button>
                <button onClick={handleOde} disabled={odeYukleniyor}
                  className="flex-1 bg-gradient-to-r from-emerald-500 to-teal-500 hover:opacity-90 text-white rounded-2xl py-4 text-[11px] font-black uppercase tracking-[0.2em] disabled:opacity-50 transition shadow-xl hover:-translate-y-1">
                  {odeYukleniyor ? 'İŞLENİYOR...' : '💰 TAHSİL ET'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Alt Bilgi ── */}
      <UsageInfo
        id="walkin-adisyon"
        color="emerald"
        title="Nasıl Kullanılır?"
        description="Walk-in adisyon sayfası, otelde konaklamayan dışarıdan gelen misafirlere hızlı satış yapmanızı ve tahsilat almanızı sağlar."
        scenarios={[
          { title: "Ürün Seçimi", content: "Stok listesinden ürünleri seçip adetlerini belirleyerek anında sepet oluşturabilirsiniz." },
          { title: "Anlık Tahsilat", content: "Adisyonu kapattığınız anda ödeme tipini (Nakit/Kart) seçerek işlemi doğrudan kasaya yansıtabilirsiniz." },
          { title: "Envanter Entegrasyonu", content: "Yaptığınız her satış, tanımlı stok listesinden otomatik olarak düşer ve maliyet takibi yapmanızı kolaylaştırır." }
        ]}
      />
    </div>
  );
}